<div class="app-titulo-pagina">
    <span>Pedido de Vale Presente</span>
</div>

<div *ngIf="!mainService.valePresenteService.pedido.itens.length"
     class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div *ngIf="mainService.valePresenteService.pedido.itens.length"
     class="col-xs-12 col-md-6 col-md-offset-3">
    <div class="panel panel-default">
        <div class="panel-heading">Detalhes</div>
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Parceiro</th>
                        <th>Valor unitário</th>
                        <th>Tipo do Vale</th>
                        <th>Quantidade</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of mainService.valePresenteService.pedido.itens">
                        <td>{{ item.valePresente.parceiro.nome }}</td>
                        <td>{{ item.valor|currency:'BRL':'symbol':'1.2-2':'pt' }}</td>
                        <td>{{ item.valePresente.virtual ? 'Virtual' : 'Físico' }}</td>
                        <td>{{ item.quantidade }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="panel panel-default">
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th colspan="2">Dados do Pedido</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-right">Número do pedido:</td> 
                        <td class="text-left">{{ mainService.valePresenteService.pedido.id }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Data de solicitação:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.solicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Status:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.status.replace("_", " ")}}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Pontos Totais:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.valorPontos }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Código de rastreio:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.codigoRastreio }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Tipo do frete:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.frete.tipoDescricao }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="mainService.valePresenteService.pedido.frete.tipo !== 'gratuito'"
         class="panel panel-default">
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th colspan="2">Endereço de Entrega</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-right">Pontos do frete:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.frete.pontos }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Destinatário:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.destinatario }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Endereço de entrega:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.logradouro }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Número:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.numero }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Complemento:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.complemento }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">CEP:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.cep }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">Cidade:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.cidade }}</td>
                    </tr>
                    <tr>
                        <td class="text-right">UF:</td>
                        <td class="text-left">{{ mainService.valePresenteService.pedido.endereco.uf }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="clearfix"></div>

<br>
<div>
    <a (click)="router.navigate(['/valepresente'])"
       class="btn btn-danger-v2">
        Voltar
    </a>
</div>
<br>


// WEBPACK FOOTER //
// ./src/app/vale-presente/vale-pedido/vale-pedido.component.html